import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import { useLocation } from "wouter";
import { ArrowLeft } from "lucide-react";
import { AtmosphericPage } from "@/components/MirrorAtmosphere";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [, setLocation] = useLocation();
  const resetMutation = useMutation({
    mutationFn: async (data: { email: string }) =>
      (await apiRequest("POST", "/api/auth/forgot-password", data)).json(),
    onSuccess: () => setSubmitted(true),
    onError: () => setError("Something went wrong. Try again."),
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    if (!email) return setError("Enter your email address");
    resetMutation.mutate({ email });
  };
  return (
    <AtmosphericPage testId="forgot-password-page" atmosphere={{ immersive: true, fill: 0.88, count: 7600, opacityScale: 0.4 }}>
      <div className="mirror-auth-layout">
        <section className="mirror-auth-composition fade-in">
          <header className="mirror-auth-brand">
            <div className="mirror-auth-title">FRACTAL</div>
            <div className="mirror-auth-subtitle">reset your password</div>
          </header>
        <div className="mirror-auth-panel">
          {submitted ? (
            <div className="space-y-4">
              <p className="type-body" data-testid="text-reset-confirmation">
                If an account with that email exists, a reset link has been generated. Contact the app admin to receive your reset link.
              </p>
              <button onClick={() => setLocation("/auth")} data-testid="button-back-to-login" className="type-body" style={{ color: "var(--accent-color)" }}>
                Back to sign in
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="mirror-form-label" htmlFor="reset-email">Email</label>
                <input id="reset-email" type="email" value={email} onChange={e => setEmail(e.target.value)} data-testid="input-reset-email" className="mirror-form-input" placeholder="you@somewhere.com" autoComplete="email" />
              </div>
              {error && <p className="type-body text-center py-1" style={{ color: "var(--status-error)" }} data-testid="text-reset-error">{error}</p>}
              <button type="submit" disabled={resetMutation.isPending} data-testid="button-send-reset" className="mirror-primary-action">
                {resetMutation.isPending ? "..." : "Send reset link"}
              </button>
            </form>
          )}
        </div>
        <button onClick={() => setLocation("/auth")} data-testid="button-back-to-auth" className="mt-6 type-body inline-flex items-center gap-2" style={{ color: "var(--text-muted)" }}>
          <ArrowLeft size={14} />Back to sign in
        </button>
        </section>
      </div>
    </AtmosphericPage>
  );
}